import React from 'react';
import { useTranslation } from 'react-i18next';

import { internalTransferApi } from 'api';
import { DialogProps, EditCategoryCommentDialog } from 'components';
import { QueryKey } from 'enums';
import { TranslationNamespace } from 'i18n';
import { InternalTransfer } from 'types';

import { InternalTransferStatusLabel } from '../InternalTransferStatusLabel';

type Props = DialogProps<InternalTransfer>;

export const EditInternalTransferDialog: React.FC<Props> = (props) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.internal_transfers',
  });

  return (
    <EditCategoryCommentDialog
      {...props}
      onUpdate={(id, values) => internalTransferApi.update(id, values)}
      queryKey={QueryKey.InternalTransfers}
      dialogTitle={t('edit_category_dialog.title')}
      categoryLabel={t('fields.category')}
      commentLabel={t('fields.comment')}
      getAssetCurrencyId={(data) => data.senderAsset?.assetCurrencyId}
      renderStatusLabel={(data) => (
        <InternalTransferStatusLabel internalTransfer={data} />
      )}
      renderUserLabel={(data) => data.senderUser?.name}
    />
  );
};
